angular.module('routes.export.ExportController', [
])

/**
 * The ExportController manages view logic rendered to the
 * case.html template for the /case view.
 *
 * @class ExportController
 * @constructor
 * @module routes.export.ExportController
 */
.controller('ExportController', [
  '$document',
  '$scope',
  '$state',
  'ExportService',
  'CasesService',
  function ($document, $scope, $state, ExportService, CasesService) {
    'use strict';

    $scope.state = $state;

    $scope.cases = {
      current: null,
      list: [],
      staging: []
    };

    $scope.spiderData = {};

    /**
     * Triggers an export of cases specifically for the Pearson Spider environment.
     */
    $scope.exportForSpider = function exportForSpider() {
      var data = ExportService.exportForSpider($scope.cases.staging, $scope.spiderData);

      var link = $document[0].createElement('a');
      link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(data));
      link.setAttribute('download', 'export-' + Date.now() + '.csv');
      link.click();
    };

    /**
     * Method sets case data from Model
     *
     * @private
     */
    function defineCaseList() {
      $scope.cases.list = CasesService.get();
      $scope.cases.staging = _.filter($scope.cases.list, 'content.publish');
    }

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      defineCaseList();
    }
    initialize();
  }
]);
